<app-base-safe-ips-index-page
  [getTableDataApiMethodName]="getTableDataApiMethodName"
  [pageTitle]="pageTitle"
  pageId="safe-ips"
>
</app-base-safe-ips-index-page>
